import * as React from "react";
import type { FormFieldProps } from "../FormFieldProps";
import type { RadioButtonGroupProps } from "./RadioButtonGroup";
import { RadioButtonGroup } from "./RadioButtonGroup";
interface BooleanRadioButtonGroupProps extends Omit<RadioButtonGroupProps<string>, keyof FormFieldProps<string>>, FormFieldProps<boolean> {
}
/* @deprecated
 * Deprecated: 18/08/2025
 * Migration guidelines: This component is deprecated and will be removed in a future release.
 * This is part of our ongoing improvements to forms and input components to enhance usability and accessibility.
 *
 * Please migrate to the RadioGroupNew component where possible.
 *
 * We recognize BooleanRadioButtonGroup has different styling; if that prevents an immediate swap, you may continue using this
 * component until all the new form components are in place.
 */
export function BooleanRadioButtonGroup({ value, onChange, ...otherProps }: React.PropsWithChildren<BooleanRadioButtonGroupProps>) {
    const stringValue = `${value}`;
    const onStringChange = React.useCallback((stringValue: string) => {
        onChange?.(stringValue === "true");
    }, [onChange]);
    return <RadioButtonGroup value={stringValue} onChange={onStringChange} {...otherProps}/>;
}
